import { useQuery } from '@tanstack/react-query'
import { compareElections, fetchElectionsWithResults } from '@/services/electionResults'

export function useElectionComparison(nationId: string | undefined, currentElectionId: string | undefined) {
  const electionsQuery = useQuery({
    queryKey: ['electionResults', 'completedIds', nationId],
    queryFn: () => fetchElectionsWithResults(nationId!),
    enabled: !!nationId,
  })

  const completedIds = electionsQuery.data
  const currentIndex = completedIds?.indexOf(currentElectionId!) ?? -1
  const previousElectionId = currentIndex >= 0 && currentIndex < (completedIds?.length ?? 0) - 1
    ? completedIds![currentIndex + 1]
    : undefined

  const comparisonQuery = useQuery({
    queryKey: ['electionResults', 'comparison', currentElectionId, previousElectionId],
    queryFn: () => compareElections(currentElectionId!, previousElectionId!),
    enabled: !!currentElectionId && !!previousElectionId,
  })

  return {
    comparison: comparisonQuery.data,
    hasPreviousElection: !!previousElectionId,
    previousElectionId,
    isLoading: electionsQuery.isLoading || comparisonQuery.isLoading,
    error: electionsQuery.error || comparisonQuery.error,
  }
}
